import { __extends } from "tslib";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Spinner } from "../Spinner";
import { IAsyncState } from "../../state/action";
import { IReportBuilderState } from "../../state/reducers";
import "../../../style/components/viewDropDowns.scss";
import { ViewRequest } from "./ViewRequest";
import { ViewResponse } from "./ViewResponse";
var ViewDropDowns = (function (_super) {
    __extends(ViewDropDowns, _super);
    function ViewDropDowns() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = function () {
            var _a = _this.props, dataFull = _a.dataFull, dataOptimized = _a.dataOptimized, file = _a.file, select = _a.select;
            return ((dataFull && dataFull.isFetching) ||
                (dataOptimized && dataOptimized.isFetching) ||
                (file && file.isFetching) ||
                (select && select.isFetching));
        };
        _this.renderViewRequest = function () {
            var showRequestViewButton = _this.props.showRequestViewButton;
            if (!showRequestViewButton) {
                return null;
            }
            return React.createElement(ViewRequest, { baseURL: _this.props.baseURL });
        };
        _this.renderViewResponse = function () {
            var showResponseViewButton = _this.props.showResponseViewButton;
            if (!showResponseViewButton) {
                return null;
            }
            return React.createElement(ViewResponse, null);
        };
        return _this;
    }
    ViewDropDowns.prototype.render = function () {
        return (React.createElement(Fragment, null,
            React.createElement("div", { className: "rb-view-dropdowns-container" },
                this.renderLoader(),
                this.renderViewRequest(),
                this.renderViewResponse())));
    };
    ViewDropDowns.prototype.renderLoader = function () {
        var loader = this.props.loader;
        if (!this.isLoading()) {
            return null;
        }
        return loader;
    };
    ViewDropDowns.defaultProps = {
        showRequestViewButton: true,
        showResponseViewButton: true,
        loader: React.createElement(Spinner, null),
    };
    return ViewDropDowns;
}(React.PureComponent));
var connected = connect(function (state) {
    var dataFull = state.dataFull, dataOptimized = state.dataOptimized, file = state.file, select = state.select;
    return {
        dataFull: dataFull,
        dataOptimized: dataOptimized,
        file: file,
        select: select,
    };
})(ViewDropDowns);
export { connected as ViewDropDowns };
